import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import styled from 'styled-components';
import { INTERIOR_PREVIEW_VALUES } from '../../constants';
import { getSirvSpinUrl, getSirvImgUrlInterior } from '../../helpers';

const STATE = {
  selected: 0,
  errorCount: 0,
};

const Base = styled.div`
  width: 600px;
  overflow: hidden;
`;

const SliderWrapper = styled(Base)`
  .slide-items {
    display: flex;
    width: ${props => {
      return `${props.spinValues.length * 600}px`;
    }};
    flex-wrap: wrap;
    transition: all 300ms;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const Item = styled.div`
  flex-basis: 600px;
  max-width: 600px;
  height: 397px;
  vertical-align: top;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  color: tomato;
  text-transform: uppercase;

  @media (max-width: 768px) {
    max-width: auto;
  }
`;

const Indicators = styled.ul`
  overflow-x: auto;
  display: flex;
  justify-content: flex-start;
  list-style: none;
  padding: 20px;
  margin-top: 10px;
  background-color: #f5f6fa;
  align-items: flex-end;
  & .indicator-block {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  & .label {
    margin: 0px;
    background-color: #0183d5;
    color: white;
  }
`;

const styles = {
  spinBlock: {
    position: 'relative',
    marginRight: 10,
    display: 'flex',
    flexDirection: 'column-reverse',
    minHeight: '100%',
  },
  imgIndicator: { marginRight: 10, cursor: 'pointer', minWidth: 140 },
};

export class Slider extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
    this.sirvBlock = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.type === 'exterior' && this.sirvChild < 3 && !!this.props.hideExteriorBlock) {
        this.props.hideExteriorBlock(false);
      }
    }, 4000);
  }

  handleClick = e => {
    let value = e.target.getAttribute('data-value');
    if (value !== null) {
      this.setState({
        selected: value,
      });
    }
  };

  get sirvChild() {
    return this.sirvBlock.current?.children.length;
  }

  render() {
    const { selected } = this.state;
    const style = this.state.selected >= 1 ? { transform: `translateX(-${selected * 600}px)` } : {};
    const renderIndicator = [];

    for (let i = 0; i < this.props.spinValues.length; i++) {
      this.props.type === 'exterior' &&
        renderIndicator.push(
          <div
            key={`sirv-${i}`}
            style={styles.spinBlock}
            ref={this.sirvBlock}
            className="Sirv"
            data-src={getSirvSpinUrl(this.props.helga_id || this.props.vehicleId, i + 1, true)}
          >
            <div data-value={i} key={i} className={selected == i ? 'active indicator-block' : 'indicator-block'}></div>
            <p className="label">normal overview</p>
          </div>,
        );
      const val = INTERIOR_PREVIEW_VALUES[i];
      if (this.props.type === 'interior') {
        renderIndicator.push(
          <img
            data-dev-vehicleid={this.props.vehicleId}
            data-value={i}
            key={INTERIOR_PREVIEW_VALUES[i]}
            style={styles.imgIndicator}
            className="Sirv"
            data-src={getSirvImgUrlInterior(this.props.helga_id || this.props.vehicleId, val)}
            onError={e => {
              this.setState(prev => ({ ...prev, errorCount: prev.errorCount + 1 }));
              return this.state.errorCount == this.props.spinValues.length - 1 ? this.props.hideBlock(false) : null;
            }}
            width="140"
            height="117"
          ></img>,
        );
      }
    }

    return (
      <SliderWrapper {...this.props}>
        {this.props.type === 'exterior' && (
          <div className="slide-items" style={style}>
            {this.props.spinValues.map((val, index) => (
              <Item className="item" key={`ext-${val}`}>
                <div
                  ref={this.sirvBlock}
                  className="Sirv"
                  data-src={getSirvSpinUrl(this.props.helga_id || this.props.vehicleId, val, false)}
                ></div>
              </Item>
            ))}
          </div>
        )}

        {this.props.type === 'interior' && (
          <div className="slide-items" style={style}>
            {this.props.spinValues.map(val => (
              <Item className="item" key={`int-${val}`}>
                <img
                  className="Sirv"
                  data-src={getSirvImgUrlInterior(this.props.helga_id || this.props.vehicleId, val)}
                  onError={e => this.props.hideBlock(false)}
                  style={{ maxWidth: '600px' }}
                  height="391"
                ></img>
              </Item>
            ))}
          </div>
        )}
        <Indicators onClick={this.handleClick}>{renderIndicator}</Indicators>
      </SliderWrapper>
    );
  }
}
